import React, {useMemo} from 'react';
import {Bar} from 'react-chartjs-2';
import ChartContainer from '../chartContainer';
import {formatNumberToDisplayWithCommas} from '../../../../../../components/common/shared';
import {getMonthlyChartLabels, getPeriodAverageValue} from '../../chartLabelHelpers';
import '../chartSetup';

const NonBillableChart = ({chartData}) => {
    const labels = useMemo(() => getMonthlyChartLabels(chartData.items), [chartData.items]);
    const values = useMemo(() => chartData.items.map(item => item.percentage), [chartData.items]);
    const targetDataset = useMemo(() => chartData.items.map(item => item.target_percentage), [chartData.items]);

    const data = useMemo(() => ({
        labels: labels,
        datasets: [
            {
                type: 'bar',
                data: values,
                backgroundColor: '#bfbfbf',
                order: 2,
                label: 'Non Billable %',
            },
            {
                type: 'line',
                data: targetDataset,
                backgroundColor: '#c00000',
                borderColor: '#c00000',
                order: 1,
                label: 'Target',
            }
        ],
    }), [labels, targetDataset, values]);

    const options = useMemo(() => ({
        scales: {
            y: {
                title: 'Non Billable %',
                beginAtZero: true,
                ticks: {
                    callback: function(value) {
                        return `${value}%`;
                    }
                }
            },
            x: {
                grid: {
                    drawOnChartArea: false,
                    tickLength: 10,
                },
                ticks: {
                    autoSkip: false,
                    maxRotation: 45,
                    minRotation: 0,
                }
            },
        },
        plugins: {
            legend: {
                reverse: true,
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        let label = context.dataset.label || '';

                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            label += `${formatNumberToDisplayWithCommas(context.parsed.y, 1)}%`;
                        }
                        return label;
                    }
                },
            },
        },
        maxBarThickness: 40,
    }), [])

    const summaryItems = useMemo(() => [
        {
            label: 'Period Avg',
            value: `${formatNumberToDisplayWithCommas(getPeriodAverageValue(chartData), 1)}%`,
        },
        {
            label: 'Current Target',
            value: `${formatNumberToDisplayWithCommas(chartData.current_target, 1)}%`,
        },
    ], [chartData]);

    return (
        <ChartContainer title="Non Billable %" summaryItems={summaryItems}>
            <Bar data={data} options={options}/>
        </ChartContainer>
    )
}

export default NonBillableChart;
